import {
  resultsetWithFields,
  formatWithPrefix,
  initChart,
  printDataChart,
  printNoDataChart
} from 'vlcishared';
import { GAUGE_CHART_OPTIONS as options } from './options-energia';
import { TEXTS_ENERGIA } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { formatValue, deepCloneWithFunctions } from './common-energia';

function obtenerConsumoMedio(resultSet) {
  return resultSet.length > 0 ? resultSet[0].consumo_medio : null;
}

function obtenerConsumoMaximoDiario(resultSet) {
  return resultSet.length > 0 ? resultSet[0].consumo_diario_maximo : null;
}

function configurarOpciones(consumoMedio, consumoMaximoDiario) {
  const chartOptions = deepCloneWithFunctions(options);
  const consumoMedioConPrefijo = formatWithPrefix(consumoMedio);

  chartOptions.title.text = TEXTS_ENERGIA[DEFAULT_LANGUAGE].get(
    'energiaConsumoMedio',
  );
  chartOptions.title.subtext = TEXTS_ENERGIA[DEFAULT_LANGUAGE].get(
    'energiaConsumoMedioDiario',
  );
  chartOptions.series[0].max = formatWithPrefix(consumoMaximoDiario).value;
  chartOptions.series[0].detail.formatter = formatValue;
  chartOptions.series[0].axisLabel.formatter = (value) =>
    Math.round(value);

  chartOptions.series[0].data[0].value = consumoMedioConPrefijo.value;

  return chartOptions;
}

export function echartGaugeConsumoMedioDiario(data) {
  const idChart = 'chartConsumoMedio';
  const idNoData = 'no_dataConsumoMedio';
  const resultSet = resultsetWithFields(data);

  if (resultSet.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);

    const consumoMedio = obtenerConsumoMedio(resultSet);
    const consumoMaximoDiario = obtenerConsumoMaximoDiario(resultSet);

    const chartOptions = configurarOpciones(consumoMedio, consumoMaximoDiario);

    initChart(idChart, chartOptions);
  }  
}
